export default __webpack_public_path__ + "images/785b61c94772cef8ad2aed2033a4790f.webp";